"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _types = require("../../../utils/types");
var _formatters = require("../../../utils/formatters");
var _helpers = require("../../../utils/helpers");
require("./TwitterView.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Tweet = function Tweet(_ref) {
  var _ref$tweet = _ref.tweet,
    content = _ref$tweet.content,
    media = _ref$tweet.media,
    date = _ref$tweet.date,
    profileImage = _ref$tweet.profileImage,
    user = _ref.user;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    i18n = _useTranslation.i18n;
  var lang = i18n.language.slice(0, 2);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-tweet"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-tweet-header"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "uin-image-icon"
  }, profileImage ? /*#__PURE__*/_react["default"].createElement("img", {
    src: profileImage,
    alt: ""
  }) : /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon anchor"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-tweet-user"
  }, /*#__PURE__*/_react["default"].createElement("p", null, user.name), /*#__PURE__*/_react["default"].createElement("span", null, user.account))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-tweet-body"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "uin-tweet-text"
  }, (0, _helpers.linkify)(content)), media && /*#__PURE__*/_react["default"].createElement("div", {
    className: 'uin-tweet-media ' + (media.length > 1 ? 'contain' : '')
  }, (0, _helpers.groupImages)(media))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-tweet-info"
  }, /*#__PURE__*/_react["default"].createElement("time", {
    dateTime: date
  }, (0, _formatters.formatTweetDate)(date, lang))));
};
Tweet.propTypes = {
  tweet: _types.messageType.isRequired,
  user: _types.contactType.isRequired
};
var _default = exports["default"] = Tweet;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/ConversationView/TwitterView/Tweet.js
// module id = 1408
// module chunks = 0